import React, { useState, useCallback, useRef } from 'react'
import Button from '@mui/material/Button'
import { makeStyles } from '@mui/styles'
import 'react-image-crop/dist/ReactCrop.css';
import ReactCrop from 'react-image-crop';

const styles = makeStyles((theme) => ({
    cropContainer: {
        position: 'relative',
        background: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 240,
        maxHeight: '60vh',
        overflow: 'hidden',
        '& .ReactCrop': {
            maxWidth: '100%',
            maxHeight: '60vh',
        },
        '& .ReactCrop img': {
            maxWidth: '100%',
            maxHeight: '60vh',
            display: 'block',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    cropButton: {
        flexShrink: 0,
        marginLeft: 16,
    },
    controls: {
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-end',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignItems: 'center',
        },
    }
})
)

const initialCrop = {
    unit: '%',
    x: 5,
    y: 5,
    width: 80,
    height: 80,
};

const ImageCropper = (props) => {
    const classes = styles();
    const [crop, setCrop] = useState(initialCrop);
    const [completedCrop, setCompletedCrop] = useState(null);
    const imgRef = useRef(null);

    const onImageLoad = useCallback((e) => {
        imgRef.current = e.currentTarget;
        // Seed completedCrop with pixel values for the initial crop so the
        // user can hit Save immediately without first dragging the selection.
        const { width, height } = e.currentTarget;
        setCompletedCrop({
            unit: 'px',
            x: (initialCrop.x / 100) * width,
            y: (initialCrop.y / 100) * height,
            width: (initialCrop.width / 100) * width,
            height: (initialCrop.height / 100) * height,
        });
    }, []);

    const getCroppedImg = (image, pixelCrop) => {
        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            pixelCrop.x * scaleX,
            pixelCrop.y * scaleY,
            pixelCrop.width * scaleX,
            pixelCrop.height * scaleY,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );
        return canvas.toDataURL();
    };

    const handleSave = () => {
        if (!imgRef.current || !completedCrop || !completedCrop.width || !completedCrop.height) {
            return;
        }
        const croppedImg = getCroppedImg(imgRef.current, completedCrop);
        props.saveCroppedImage(croppedImg);
    };

    return (
        <div>
            <div className={classes.cropContainer}>
                <ReactCrop
                    crop={crop}
                    onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
                    onComplete={(pixelCrop) => setCompletedCrop(pixelCrop)}
                    keepSelection
                >
                    <img
                        ref={imgRef}
                        src={props.src}
                        alt="Crop preview"
                        onLoad={onImageLoad}
                    />
                </ReactCrop>
            </div>
            <div className={classes.controls}>
                <Button onClick={handleSave} color="primary">
                    Save
                </Button>
                <Button onClick={props.onClose} color="primary">
                    Close
                </Button>
            </div>
        </div>
    );
};

export default ImageCropper;